<h3>Cadastrar Pendência

    <button class="btn btn-sm  btn-primary pull-right" (click)="openModalPendencia()">Nova Pendência</button>
  </h3>
  
  <hr>  
  
  <div class="box box-default box-solid collapsed-box animated fadeInDown" *ngFor="let lista of listaPendencia" >
    <div class="box-header with-border">
      <h3 class="box-title">{{lista}}</h3>
      <div class="box-tools pull-right">
        <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-plus"></i>
        </button>
      </div>
    </div>
    
 

    <!--CONVENIO-->
    <div class="box-body" style="display: none;" *ngIf="lista == 'Convênio'" >
      
        <table class="table table-hover">
            <tbody>
              <tr>
                <th>Descrição</th>
                
                <th class="text-center">Ações</th>
              </tr>
              <tr >
                
                  <td> Prefeitura de Teresina
                  </td>
                  
                  <td class="text-center">
                      <span class="badge bg-gray cursor" pTooltip="Editar perfil" tooltipPosition="top" ><i class="far fa-edit"></i></span>
                    
                  </td>
              
  
              </tr>
            </tbody>
          </table>
  
    </div>
    <!-- PARCERIA-->
    <div class="box-body" style="display: none;" *ngIf="lista == 'Parceria'" >
      
        <table class="table table-hover">
            <tbody>
              <tr>
                <th>Descrição</th>
                
                <th class="text-center">Ações</th>
              </tr>
              <tr >
                
                  <td> Instituto Samara Sena
                  </td>
                  
                  <td class="text-center">
                      <span class="badge bg-gray cursor" pTooltip="Editar perfil" tooltipPosition="top" ><i class="far fa-edit"></i></span>
                    
                  </td>
              
  
              </tr>
            </tbody>
          </table>
  
    </div>
    
  </div> 
   <!--======= Modal Nova Pendencia -->
   <p-dialog [style]="{width: '600px'}" header="Pendência" [(visible)]="modalPendencia" showEffect="fade" >
        <div class="form-group col-sm-12" style="margin-bottom: 0;">
          <h3>Nova Pedência</h3>
          <hr>
        </div>        
      
        <div class="form-group col-sm-12 ui-fluid">
             <p-select name="situacao" [options]="situacaoPendencia" placeholder="Selecione situação" required>
             </p-select>         
        </div>
    
        <div class="form-group col-sm-12 ui-fluid">
            <p-select name="concedente" [options]="listaConcedente" placeholder="Selecione concedente" required>
            </p-select>
        </div>
    
        <div class="form-group col-sm-12 ui-fluid"  >
             <p-select name="Prefeitura" [options]="listaPrefeitura" placeholder="Selecione Prefeitura" required>
             </p-select>
        </div>
         
        <div class="form-group col-sm-12 ui-fluid" >
             <p-select name="OSC" [options]="listaOsc" placeholder="Selecione Osc" required>
             </p-select>
        </div>
    
        <div class="form-group col-sm-12">
            <label> Projeto com pendência</label>
          <input type="text" class="form-control" placeholder="nome" >
        </div>

        <div class="form-group col-sm-12">
            <label> Liberação de pendência</label>
          <textarea type="textarea" class="form-control" placeholder="Descrição para liberação de pendência" >
          </textarea>
        </div>
  </p-dialog>
      <!--=======. Modal -->

  
  
  
  
 